import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance, { DefaultRoutingProvider } from '@bugsnag/browser-performance'
import {
    SETTLE_IGNORE_URLS,
    createRouteResolver,
    networkRequestCallback,
    releaseStageFor,
} from '~/assets/js/performance'

const apiKey = 'c404b402a31b7d8a0ae5a5851b67e578'

// O Nuxt expõe as variáveis NUXT_ENV_VERCEL_* nos builds da Vercel: o commit
// identifica o deploy, para comparar a performance antes e depois de cada um
const appVersion = (process.env.NUXT_ENV_VERCEL_GIT_COMMIT_SHA || 'local').slice(0, 7)
const releaseStage = releaseStageFor(window.location.hostname)

// Preenchido quando o Nuxt chama o plugin; o SDK só resolve a rota no fim do carregamento
let router = null

Bugsnag.start({
    apiKey,
    appVersion,
    releaseStage,
    plugins: [new BugsnagPluginVue()],
})

BugsnagPerformance.start({
    apiKey,
    appVersion,
    releaseStage,
    // Só mede tráfego publicado (produção e previews), não o ambiente local
    enabledReleaseStages: ['production', 'preview'],
    serviceName: 'unico-checkout',
    // Agrupa por /:page e /customer/:transaction, não um item por produto ou pedido
    routingProvider: new DefaultRoutingProvider(createRouteResolver(() => router)),
    // Não há navegação interna relevante, e o pushState do popup de saída
    // (PageLayout) viraria uma "mudança de rota" em todo acesso
    autoInstrumentRouteChanges: false,
    networkRequestCallback,
    settleIgnoreUrls: SETTLE_IGNORE_URLS,
    // A URL e o referrer trazem ?ch= (hash do cliente), UTMs e o hash do pedido;
    // a rota já identifica a página
    sendPageAttributes: { url: false, referrer: false },
})

const bugsnagVue = Bugsnag.getPlugin('vue')

bugsnagVue.installVueErrorHandler(Vue)

export default function ({ app }) {
    router = app.router
}
